  <div *ngIf="isFansZero || isFirstnetCustomer" class="alert valign-children-middle" id="error-main-container">
    <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
        <i class="icon-badgealert"></i>
    </div>
    <div>
        <h2>Error</h2>
        <p class="error-message" *ngIf = "isFirstnetCustomer">{{selectAccounts.firstNetErrorMessagefirstPart}}<a href='http://localcontrol.firstnet.com' class="firstnetErrorMessageLink" target="_blank"> here </a>{{selectAccounts.firstNetErrorMessageSecondPart}}</p>
        <p class="error-message" *ngIf = "isFansZero && !isFirstnetCustomer">{{selectAccounts.errorMessage}}</p>
    </div>
  </div>
  <div class="main-div" *ngIf="!isFirstnetCustomer && !isFansZero">
    <form [formGroup]="form">
        <!-- <div class="info-box">
            <p class="heading1">{{selectAccounts.info}}</p><br>
            <h3>{{selectAccounts.subHeading1}}</h3>
            <ul>
                <li *ngFor="let req of selectAccounts.requirements">{{req}}</li>
            </ul>
            <br/>
            <h3>{{selectAccounts.subHeading2}}</h3>
            <div class="offers">
                <div class="offer1">
                    <p class="offer-headings">{{selectAccounts.offer1.heading}}</p>
                    <ul>
                        <li>
                            <p class="offers-rates">{{selectAccounts.offer1.description}}</p>
                        </li>
                    </ul>
                </div>
                <div class="offer2">
                  <p class="offer-headings">{{selectAccounts.offer2.heading}}</p>
                  <ul>
                      <li>
                          <p class="offers-rates">{{selectAccounts.offer2.description}}</p>
                      </li>
                  </ul>
                </div>
            </div>
            <div class="offers-1">
              <div class="offer1">
                  <p class="offer-headings">{{selectAccounts.offer3.heading}}</p>
                  <ul>
                      <li>
                          <p class="offers-rates">{{selectAccounts.offer3.description}}</p>
                      </li>
                  </ul>
              </div>
              <div class="offer2">
                <p class="offer-headings">{{selectAccounts.offer4.heading}}</p>
                <ul>
                    <li>
                        <p class="offers-rates">{{selectAccounts.offer4.description}}</p>
                    </li>
                </ul>
              </div>
          </div>
        </div> -->
        <p class="heading" style="padding-left: 0px !important;">{{selectAccounts.heading}}</p><br>
        <p class="sub-heading">{{selectAccounts.subHeading}}</p>
        <div class="fan-section">
            <app-customgrid [gridOptions]="gridOptions">
                <ng-template let-row="row">
                    <label for="'fan-no' + {{row}}" class="checkbox">
                        <input type="checkbox" name="fan-no" (click)="isFanSelected=true;onRowClick(row);"
                            aria-label="Foundation Account" id="'fan-no' + {{row}}" class="fan-no" [checked]="(this.selectedFanList.length > 0 && this.selectedFanList.includes(row)) ? true : false">
                        <i class="skin"></i>
                        <span class="formSpan" id="completeSpan + {{row}}">{{row}}</span>
                    </label>
                </ng-template>
            </app-customgrid>
        </div>
        <!-- <p *ngIf="isFanSelected">{{selectAccounts.selectOneAccount}}</p> -->
        <div class="enrollment-type-section">
            <p class="enrollment-type-heading">{{selectAccounts.enrollmentTypeHeading}}</p>
            <p class="enrollment-type-description">{{selectAccounts.enrollmentTypeDescription}}</p>
            <div>
                <div class="flex-section">
                    <div>
                    <label for="off1" class="checkbox first">
                        <input type="checkbox" name="Enrollment-Type" (click)="setOption(selectAccounts.type1);"
                            id="off1" value={{selectAccounts.type1}} [checked]="(enrolledData && enrolledData.serviceRequested.includes(selectAccounts.type1)) ? true : false">
                        <i class="skin"></i>
                        <span class="option-name">{{selectAccounts.type1}}</span>
                         <br>
                        <span class="option-subname">{{selectAccounts.typeDescription1}}</span>
                    </label>
                    </div>
                </div>
                <div class="flex-section">
                    <div>
                        <label for="off2" class="checkbox second">
                            <input type="checkbox" name="Enrollment-Type" (click)="setOption(selectAccounts.type2);"
                                tabindex="0" id="off2" value={{selectAccounts.type2}} [checked]="(enrolledData && enrolledData.serviceRequested.includes(selectAccounts.type2)) ? true : false">
                            <i class="skin"></i>
                            <span class="option-name">{{selectAccounts.type2}}</span>
                             <br>
                            <span class="option-subname">{{selectAccounts.typeDescription2}}</span>
                        </label>
                    </div>
                </div>
                <input type="radio" [disabled]="true" id="heading" class="radio-btn"> 
                <label for="heading" class="checkbox second secondHeading sub-heading1">Coming soon(Check with your account manager for availability)</label><br> 
                <div class="flex-section"> 
                    <div>
                        <label for="off3" class="checkbox third">
                            
                            <span class="option-name">{{selectAccounts.type3}}</span>
                           <br>
                            <span class="option-subname">{{selectAccounts.typeDescription3}}</span>
                        </label>
                    </div>
                </div>
              <div class="flex-section">
                <div>
                    <label for="off4" class="checkbox fourth">
                       
                        <span class="option-name">{{selectAccounts.type4}}</span> 
                      <br>
                        <span class="option-subname">{{selectAccounts.typeDescription4}}</span>
                    </label>
                </div>
              </div>
              <div class="flex-section"> 
                <div>
                    <label for="off5" class="checkbox third">
                        <!-- <input type="checkbox" [disabled]="true" name="Enrollment-Type" (click)="setOption(selectAccounts.type5);"
                            tabindex="0" id="off5" value={{selectAccounts.type5}} [checked]="(enrolledData && enrolledData.serviceRequested.includes(selectAccounts.type5)) ? true : false">
                        <i class="skin"></i> -->
                        <span class="option-name">{{selectAccounts.type5}}</span>
                       <br>
                        <span class="option-subname">{{selectAccounts.typeDescription5}}</span>
                    </label>
                </div>
            </div>
            <div class="flex-section"> 
                <div>
                    <label for="off6" class="checkbox third">
                        <!-- <input type="checkbox" [disabled]="true" name="Enrollment-Type" (click)="setOption(selectAccounts.type6);"
                            tabindex="0" id="off6" value={{selectAccounts.type6}} [checked]="(enrolledData && enrolledData.serviceRequested.includes(selectAccounts.type6)) ? true : false">
                        <i class="skin"></i> -->
                        <span class="option-name">{{selectAccounts.type6}}</span>
                       <br>
                        <span class="option-subname">{{selectAccounts.typeDescription6}}</span>
                    </label>
                </div>
            </div>
            </div> 
        </div><br>
        <!-- <div>
            <p class="contact-heading" style="line-height: 30px;">{{selectAccounts.solutionTypeHeading}}</p>
            <p style="margin-bottom: 10px;">{{selectAccounts.solutionType1}}</p>
            <p style="margin-bottom: 10px;">{{selectAccounts.solutionType2}}</p>
            <p style="margin-bottom: 10px;">{{selectAccounts.solutionType3}}</p>
            <p style="margin-bottom: 10px;">{{selectAccounts.solutionType4}}</p>
            <p style="margin-bottom: 10px;">{{selectAccounts.solutionType5}}</p>
            <p style="margin-bottom: 10px;">{{selectAccounts.solutionType6}}</p>
        </div> -->
        <div class="contact-section">
            <p class="contact-heading">{{selectAccounts.contactHeading}}</p>
            <p class="phone-number"><span class="span-bold">{{selectAccounts.phoneNumber}}</span> {{userPhoneNumber}}</p>
            <p class="email"><span class="span-bold">{{selectAccounts.email}}</span> {{userEmail}}</p>
            <label [ngClass]="isContactNameInvalid ? 'contact-name-label error-field' : 'contact-name-label'" for="contact-name">{{selectAccounts.preferredContactName}}</label>
            <div class="contact-name-field">
                <input id="contact-name" type="text" [ngClass]="isContactNameInvalid ? 'form-control text-error' : 'form-control'" placeholder="{{selectAccounts.preferredContactNamePlaceholder}}"
                    formControlName="contactName1" [(ngModel)]="contactName" (keyup)="checkContactNameFormat()" />
            </div>
            <div class="contact-name-error-field" *ngIf="isContactNameInvalid">
                <div class="text-danger">{{selectAccounts.preferredContactNameErrorMessage}}</div>
            </div>
        </div><br>
        <div class="contact-number-section">
          <label [ngClass]="isContactNumberInvalid ? 'contact-number-label error-field' : 'contact-number-label'" for="contact-number">{{selectAccounts.preferredContactNumber}}</label>
          <div class="contact-number-field">
              <input id="contact-number" type="text" [ngClass]="isContactNumberInvalid ? 'form-control text-error' : 'form-control'" placeholder="{{selectAccounts.preferredContactNumberPlaceholder}}"
                  formControlName="contactNumber1" [(ngModel)]="contactNumber" (keyup)="checkContactNumberFormat()" [numberOnly]=true [ctnmask]=true />
          </div>
          <div class="contact-number-error-field" *ngIf="isContactNumberInvalid">
              <div class="text-danger">{{selectAccounts.preferredContactNumberErrorMessage}}</div>
          </div>
        </div><br>
        <div class="time-section">
            <label class="time-period-label" for="timeZone">{{selectAccounts.preferredTimeToContact}}
            </label>
            <div class="time-period-field">
                <app-dropdown [options]="timeZoneValues" [labelId]="'timeZone'"
                    [placeholderAriaLabel]="'Select a time zone'" id="time-period" [prePopulateValue]="(enrolledData && enrolledData.bestTimeToContact != 'Not Specified') ? timeZoneName : 'Select'"
                    (selectEmit)="selectTimeZone($event)" [inputId]="'selectTime'"> 
                </app-dropdown>
                <br>
                <app-dropdown [options]="timeOfDay" [labelId]="'timeDay'"
                    [placeholderAriaLabel]="'Select a time of the day'" id="time-day" [prePopulateValue]="(enrolledData && enrolledData.bestTimeToContact != 'Not Specified') ? dayTimeSlotName : 'Select'" 
                     (selectEmit)="selectTimeDay($event)" [inputId]="'selectTimeDay'" *ngIf="showAvailableTime">
                </app-dropdown>
            </div>
        </div><br>
        <div class="acknowledgement-section">
            <p class="acknowledgement-heading">{{selectAccounts.legalAgreements}}</p>
            <p class="acknowledgement-subheading">Use of AT&T’s Device Management Program<sup>TM</sup> is subject to the
                <a target="_blank" [href]="staticTCUrl">Terms of Use for AT&T’s Device Management Program</a>.</p>
        </div>
        <div class="continue-section">
            <!-- Changing route from learn/5g to home temporarily as a part of US-1367 -->
            <button class="btn btn-secondary" id="continue-option" (click)="continueToNext()"
                [disabled]="isDisabled">{{selectAccounts.continue}}</button><a id="cancel-option" [routerLink]="['/learn']">{{selectAccounts.cancel}}</a>
        </div>
    </form>
  </div>